import { render, staticRenderFns } from "./FieldType24Configure.vue?vue&type=template&id=1b7024bc&scoped=true"
import script from "./FieldType24Configure.vue?vue&type=script&lang=js"
export * from "./FieldType24Configure.vue?vue&type=script&lang=js"
import style0 from "./FieldType24Configure.vue?vue&type=style&index=0&id=1b7024bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7024bc",
  null
  
)

export default component.exports